<template>
  <div>
    <!-- 弹窗 -->
    <el-dialog title="指派工单" :visible.sync="dialogShow" class="dialogform" width="400px">
      <el-select v-model="userid" filterable placeholder="请选择">
        <el-option v-for="item in users" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDoClick">确定</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗 end-->
  </div>
</template>

<script>
import { manageAssign, manageUsers } from "@/api/pay/workorder";
export default {
  props: {
    callback: Function,
  },
  data() {
    return {
      dialogShow: false, //
      workid: 0,
      userid: null,
      loading: null,
      users: []
    };
  },
  mounted() {},
  methods: {
    //
    handleAssignClick(workid, curuid) {
      this.$mLoading.show();
      this.users = [];
      this.workid = workid;
      this.userid = null;
      manageUsers().then(res => {
        this.$mLoading.close();
        if (res.data.code == "0000") {
          let arr = res.data.data;
          let users = [];
          for (let i = 0; i < arr.length; i++) {
            if (curuid == arr[i].user_id) {
              continue;
            }
            users.push({ value: arr[i].user_id, label: arr[i].user_name });
          }
          this.users = users;
          console.log(this.users);
          this.dialogShow = true;
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    /**
     * 指派
     */
    handleDoClick() {
      if(this.userid==null){
        this.$message.warning("请选择要指派的用户");
        return;
      }
      this.$mLoading.show();
      manageAssign(this.workid, this.userid).then(res => {
        this.$mLoading.close();
        if (res.data.code == "0000") {
          this.dialogShow = false;
          if(this.callback){
            this.callback(this.workid, this.userid);
          }
        } else {
          this.$message.warning(res.data.message);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>


